<div class="market-prices-page">

    <!-- Page Header -->
    <div class="prices-header">
        <div class="container">
            <div class="header-top">
                <div>
                    <h1 class="header-title">{{ 'market_prices_page.title' | translate }}</h1>
                    <p class="header-subtitle">{{ 'market_prices_page.subtitle' | translate }}</p>
                </div>
                <button class="btn btn-refresh" (click)="country = 'All'; search = ''; category = 'All'; page = 1;">
                    <i class="fa fa-sync-alt me-1"></i> {{ 'market_prices_page.refresh' | translate }}
                </button>
            </div>

            <!-- Country Filters -->
            <div class="country-filters">
                <span class="filter-label"><i class="fa fa-globe me-1"></i> {{ 'market_prices_page.filter_by_country' | translate }}:</span>
                <button
                    *ngFor="let c of countries"
                    class="btn country-pill"
                    [class.active]="country === c.key"
                    (click)="setCountry(c.key)"
                >
                    {{ c.flag }} {{ c.labelKey | translate }}
                </button>
            </div>

            <!-- Stats Cards -->
            <div class="row g-3 mt-3">
                <div class="col-4">
                    <div class="stat-card">
                        <div class="stat-value">54</div>
                        <div class="stat-label">{{ 'market_prices_page.stat_products_tracked' | translate }}</div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="stat-card">
                        <div class="stat-value">23</div>
                        <div class="stat-label">{{ 'market_prices_page.stat_active_markets' | translate }}</div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="stat-card">
                        <div class="stat-value">6</div>
                        <div class="stat-label">{{ 'market_prices_page.stat_cemac_countries' | translate }}</div>
                    </div>
                </div>
            </div>
            <div class="last-updated">{{ 'market_prices_page.last_updated' | translate: { date: lastUpdatedDate } }}</div>
        </div>
    </div>

    <!-- Content -->
    <div class="container prices-content">

        <!-- Top Variations + Market Snapshot -->
        <div class="row g-4 mb-5">
            <div class="col-lg-6">
                <h2 class="section-heading"><i class="fa fa-chart-line me-2"></i> {{ 'market_prices_page.top_movers' | translate }}</h2>
                <div class="row g-3">
                    <div class="col-6" *ngFor="let item of topVariations">
                        <div class="top-mover-card">
                            <div class="top-mover-name">{{ item.nameKey | translate }}</div>
                            <div class="top-mover-category">{{ item.categoryKey | translate }}</div>
                            <div class="top-mover-price">{{ item.price }}</div>
                            <div class="top-mover-change trend-up">
                                <i class="fa fa-arrow-up me-1"></i> {{ item.change }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h2 class="section-heading mb-0"><i class="fa fa-chart-bar me-2"></i> {{ 'market_prices_page.market_snapshot' | translate }}</h2>
                    <span class="country-flag">{{ activeCountry.flag }} {{ activeCountry.labelKey | translate }}</span>
                </div>
                <div class="row g-3" *ngIf="snapshotGroups.length > 0">
                    <div class="col-sm-6" *ngFor="let g of snapshotGroups">
                        <div class="snapshot-card">
                            <h3 class="snapshot-cat">{{ g.catKey | translate }}</h3>
                            <div class="snapshot-items">
                                <div class="snapshot-item" *ngFor="let item of g.items">
                                    <div class="snapshot-item-info">
                                        <div class="snapshot-item-name">{{ item.product }}</div>
                                        <div class="snapshot-item-market"><i class="fa fa-map-marker-alt me-1"></i> {{ item.market }}</div>
                                    </div>
                                    <div class="snapshot-item-price">
                                        <div class="snapshot-item-xaf">{{ item.xaf }}</div>
                                        <span class="trend-badge" [ngClass]="badgeColor(item.trend)">
                                            {{ item.trend }} {{ item.change }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="empty-state" *ngIf="snapshotGroups.length === 0">
                    {{ 'market_prices_page.no_data_country' | translate }}
                </div>
            </div>
        </div>

        <!-- Price Table -->
        <section class="mb-5">
            <h2 class="section-heading"><i class="fa fa-shopping-basket me-2"></i> {{ 'market_prices_page.section_title' | translate }}</h2>

            <!-- Filters -->
            <div class="row g-3 mb-4">
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control search-input"
                        [placeholder]="'market_prices_page.search_placeholder' | translate"
                        [value]="search"
                        (input)="onSearch($event)"
                    />
                </div>
                <div class="col-md-4">
                    <select class="form-select category-select" [value]="category" (change)="onCategory($event)">
                        <option *ngFor="let c of categories" [value]="c.key">{{ c.labelKey | translate }}</option>
                    </select>
                </div>
            </div>

            <!-- Table -->
            <div class="table-container">
                <table class="table price-table">
                    <thead>
                        <tr>
                            <th>{{ 'market_prices_page.table.product' | translate }}</th>
                            <th class="d-none d-md-table-cell">{{ 'market_prices_page.table.category' | translate }}</th>
                            <th>{{ 'market_prices_page.table.market' | translate }}</th>
                            <th class="d-none d-sm-table-cell">{{ 'market_prices_page.table.country' | translate }}</th>
                            <th class="text-end">{{ 'market_prices_page.table.price_xaf' | translate }}</th>
                            <th class="text-end d-none d-sm-table-cell">{{ 'market_prices_page.table.price_usd' | translate }}</th>
                            <th class="text-center">{{ 'market_prices_page.table.trend' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="pageRows.length === 0">
                            <td colspan="7" class="text-center py-4 text-muted">{{ 'market_prices_page.table.no_results' | translate }}</td>
                        </tr>
                        <tr *ngFor="let row of pageRows; let i = index" [class.row-alt]="i % 2 === 1">
                            <td class="fw-medium">{{ row.product }}</td>
                            <td class="d-none d-md-table-cell">
                                <span class="category-badge">{{ row.category }}</span>
                            </td>
                            <td class="text-muted"><i class="fa fa-map-marker-alt me-1"></i> {{ row.market }}</td>
                            <td class="d-none d-sm-table-cell text-muted">{{ row.country }}</td>
                            <td class="text-end fw-bold">{{ row.xaf }}</td>
                            <td class="text-end d-none d-sm-table-cell text-muted">{{ row.usd }}</td>
                            <td class="text-center">
                                <span class="trend-badge" [ngClass]="badgeColor(row.trend)">
                                    {{ row.trend }} {{ row.change }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Pagination -->
            <div class="pagination-bar" *ngIf="filtered.length > 0">
                <span class="pagination-info">
                    {{ 'market_prices_page.pagination.showing' | translate: { start: pageStart + 1, end: showingEnd, total: filtered.length } }}
                </span>
                <div class="pagination-buttons" *ngIf="totalPages > 1">
                    <button class="btn btn-page" [disabled]="currentPage === 1" (click)="prevPage()">
                        <i class="fa fa-chevron-left"></i> {{ 'market_prices_page.pagination.prev' | translate }}
                    </button>
                    <button
                        *ngFor="let p of pageNumbers"
                        class="btn btn-page"
                        [class.active]="p === currentPage"
                        (click)="setPage(p)"
                    >
                        {{ p }}
                    </button>
                    <button class="btn btn-page" [disabled]="currentPage === totalPages" (click)="nextPage()">
                        {{ 'market_prices_page.pagination.next' | translate }} <i class="fa fa-chevron-right"></i>
                    </button>
                </div>
            </div>
        </section>

        <!-- Buying Tips -->
        <section class="mb-5">
            <h2 class="section-heading"><i class="fa fa-lightbulb me-2"></i> {{ 'market_prices_page.buying_tips_title' | translate }}</h2>
            <div class="row g-3">
                <div class="col-sm-6 col-lg-4" *ngFor="let tip of buyingTips">
                    <div class="buying-tip-card">
                        <div class="buying-tip-market">{{ tip.marketKey | translate }}</div>
                        <div class="buying-tip-city">{{ tip.cityKey | translate }}</div>
                        <div class="buying-tip-savings">{{ 'market_prices_page.buying_tips.savings' | translate: { percent: tip.savingsPercent } }}</div>
                    </div>
                </div>
            </div>
        </section>

    </div>

</div>